import React, { useMemo } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { BookmarkFill } from "react-bootstrap-icons";
import { useFormikContext } from "formik";
import type {
  IDishDetailsFormValues,
  IDishDetailsModalViewModel,
} from "@/types";
import { getOptionQuantity } from "@/pages/menuItemsPage/helpers/supplementsHelpers";
import { useTranslation } from "react-i18next";
import { safeNumber } from "@/pages/menuItemsPage/helpers";

interface DishDetailsModalFooterProps {
  viewModel: IDishDetailsModalViewModel;
  formId: string;
}

const DishDetailsModalFooter: React.FC<DishDetailsModalFooterProps> = ({
  viewModel,
  formId,
}) => {
  const { t } = useTranslation();
  const { values, isSubmitting } = useFormikContext<IDishDetailsFormValues>();

  const selectedPortionPrice = useMemo(() => {
    const selected = (viewModel.portions ?? []).find(
      (p) => p.id === values.portionId
    );
    return safeNumber(selected?.price);
  }, [viewModel.portions, values.portionId]);

  const supplementsTotal = useMemo(() => {
    let sum = 0;

    for (const group of viewModel.supplements ?? []) {
      for (const option of group.options ?? []) {
        const optionQty = getOptionQuantity(
          values.supplements,
          group.id,
          option.id
        );
        sum += safeNumber(option.price) * optionQty;
      }
    }

    return sum;
  }, [viewModel.supplements, values.supplements]);

  const total: number =
    (selectedPortionPrice + supplementsTotal) * values.dishQuantity;
  const totalText = `${total.toFixed(2)} ${viewModel.currency}`;

  return (
    <Row className="w-100 g-3 align-items-center justify-content-center m-0">
      <Col xs={12} md="auto" className={"px-0 m-0"}>
        <Button
          type="submit"
          form={formId}
          disabled={isSubmitting}
          className="w-100 w-md-auto flex-grow-1 flex-md-grow-0 align-items-center lh-1"
        >
          <span className="d-inline-flex align-items-center gap-2">
            <BookmarkFill className="fs-6" />
            <span className="fs-14 fw-bold d-inline-block lh-1">
              {t("Add")} {values.dishQuantity} {t("btnDetailsModal.for")}{" "}
              {totalText}
            </span>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default React.memo(DishDetailsModalFooter);
